import { getUniDrivers } from '../api/driver';

export const GET_DRIVERS = 'GET_DRIVERS';

function getDrivers(drivers, error=null) {
    return {
        type: GET_DRIVERS,
        drivers,
        error
    }
}

export function handleGetDrivers(id) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await getUniDrivers(id, getState().authedUser.token);
            if(result){
                const drivers = result.data.data;
                // dispatch(hideLoading());
                return dispatch(getDrivers(drivers));
            } else {
                // dispatch(hideLoading())
                return dispatch(getDrivers(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getDrivers(null, error));
        }
    }
}

// Emptying the Drivers store
export function restoreDrivers() {
    return async (dispatch) => {
        return dispatch(getDrivers(null));
    }
}